export default __webpack_public_path__ + "static/media/IMG_20230718_175019 - Sahaj Srivastava.e58055b9.jpg";